/**
 * loadNavContent - グロナビコンテンツ読み込み
 * @param  {NodeList} targets ターゲットとなる要素群
 * @return {Void}
 */
// お気に入りボタンの更新
import {updateAllButtonState} from './favoriteButton';

const loadNavContent = (targets) => {
    if (!targets.length || targets === null) {
        return;
    }

    const contentBaseUrl = `${window.location.origin}/assets/include/`;
    const ctrls = Array.from(targets);
    const contents = Array.from(document.querySelectorAll('[data-load-content]'));
    const loadContentNames = {};
    const contentIds = [];
    const loadedContentIds = [];

    const methods = {
        /**
         * init - 初期化
         */
        init() {
            // コンテンツのid名と、読み込むコンテンツのファイル名を取得
            for (const content of contents) {
                const contentId = content.id;

                contentIds.push(contentId);
                loadContentNames[contentId] = content.dataset.loadContent;
            }

            methods.addEvent();
        },
        /**
         * addEvent - イベントバインド
         */
        addEvent() {
            for (const ctrl of ctrls) {
                const {loadTarget} = ctrl.dataset;

                if (!contentIds.includes(loadTarget)) {
                    continue;
                }

                for (const event of ['focus', 'touchstart', 'mouseenter']) {
                    ctrl.addEventListener(event, () => {
                        // すでに読み込まれている場合は何もしない
                        if (loadedContentIds.indexOf(loadTarget) !== -1) {
                            return;
                        }

                        loadedContentIds.push(loadTarget);
                        methods.loadContent(loadTarget);
                    }, {
                        passive: true,
                        once: true
                    });
                }
            }
        },
        /**
         * loadContent - コンテンツの読み込みを実行
         * @param  {String} targetId 読み込むコンテンツのid名
         * @return {[Void]}
         */
        loadContent(targetId) {
            const [targetContent] = contents.filter((element) => element.id === targetId);
            const loadContent = loadContentNames[targetId];

            // 読み込むコンテンツが見つからない場合は何もしない
            if (!loadContent) {
                return;
            }

            event.stopImmediatePropagation();
            event.stopPropagation();

            fetch(`${contentBaseUrl}${loadContent}.html`).then((response) => response.text()).then((text) => {
                targetContent.insertAdjacentHTML('beforeend', text);
                updateAllButtonState(targetContent.querySelectorAll('.c-button-favorite[data-id]'));
            });
        }
    };

    // 初期化を実行
    methods.init();
};

/**
 * デフォルト実行処理
 * @return {Void}
 */
export default () => loadNavContent(document.querySelectorAll('[data-load-target]'));
